/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RewardPostWinConfigText } from './RewardPostWinConfigText';
import {
    RewardPostWinConfigTextFromJSON,
    RewardPostWinConfigTextFromJSONTyped,
    RewardPostWinConfigTextToJSON,
} from './RewardPostWinConfigText';
import type { RewardCategory } from './RewardCategory';
import {
    RewardCategoryFromJSON,
    RewardCategoryFromJSONTyped,
    RewardCategoryToJSON,
} from './RewardCategory';
import type { RarityCode } from './RarityCode';
import {
    RarityCodeFromJSON,
    RarityCodeFromJSONTyped,
    RarityCodeToJSON,
} from './RarityCode';

/**
 * A prize as shown outside GDS: everything about it except the backend-only data the reward assignment plugin uses.
 * GDS's reward types extend this with that data.
 * @export
 * @interface RewardTypeSummary
 */
export interface RewardTypeSummary {
    /**
     * The relative rarity of this reward in the schedule, reflecting its desirability as a prize.
     * @type {RarityCode}
     * @memberof RewardTypeSummary
     */
    rarity: RarityCode;
    /**
     * Free-form group IDs for reward types in a schedule. All reward types with the same wheelId can be displayed
     * together on a spin-to-win wheel. Rewards non-overlapping wheelId values will not be displayed together.
     * @type {Array<string>}
     * @memberof RewardTypeSummary
     */
    wheelIds: Array<string>;
    /**
     * Details about an award that should be shown to the user after it has been won.  This could optionally include
     * a call to action such as a link
     * @type {RewardPostWinConfigText}
     * @memberof RewardTypeSummary
     */
    postWinConfig: RewardPostWinConfigText;
    /**
     * 
     * @type {RewardCategory}
     * @memberof RewardTypeSummary
     */
    rewardCategory: RewardCategory;
    /**
     * 
     * @type {number}
     * @memberof RewardTypeSummary
     */
    cashValueInCents: number;
    /**
     * The percentage of prizes that should be distributed to this reward type if a non-quantity prize is won. Either
     * quantity or quantityPercentage must be defined, but not both.
     * 
     * A RewardSchedule must have at least one prize with a quantityPercentage defined to be valid.
     * 
     * If multiple rewardTypes have a quantityPercentage in the same schedule, the total of all the quantityPercentage
     * fields across all of them must equal exactly 100. If there is only one prize with a quantityPercentage, the value
     * must be 100.
     * @type {number}
     * @memberof RewardTypeSummary
     */
    quantityPercentage?: number | null;
    /**
     * The fixed quantity of prizes available of this type. Either quantity or quantityPercentage must be defined, but
     * not both.
     * @type {number}
     * @memberof RewardTypeSummary
     */
    quantity?: number;
    /**
     * 
     * @type {string}
     * @memberof RewardTypeSummary
     */
    rewardName: string;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof RewardTypeSummary
     */
    id: string;
}



/**
 * Check if a given object implements the RewardTypeSummary interface.
 */
export function instanceOfRewardTypeSummary(value: object): value is RewardTypeSummary {
    if (!('rarity' in value) || value['rarity'] === undefined) return false;
    if (!('wheelIds' in value) || value['wheelIds'] === undefined) return false;
    if (!('postWinConfig' in value) || value['postWinConfig'] === undefined) return false;
    if (!('rewardCategory' in value) || value['rewardCategory'] === undefined) return false;
    if (!('cashValueInCents' in value) || value['cashValueInCents'] === undefined) return false;
    if (!('rewardName' in value) || value['rewardName'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function RewardTypeSummaryFromJSON(json: any): RewardTypeSummary {
    return RewardTypeSummaryFromJSONTyped(json, false);
}

export function RewardTypeSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): RewardTypeSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'rarity': RarityCodeFromJSON(json['rarity']),
        'wheelIds': json['wheelIds'],
        'postWinConfig': RewardPostWinConfigTextFromJSON(json['postWinConfig']),
        'rewardCategory': RewardCategoryFromJSON(json['rewardCategory']),
        'cashValueInCents': json['cashValueInCents'],
        'quantityPercentage': json['quantityPercentage'] == null ? undefined : json['quantityPercentage'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'rewardName': json['rewardName'],
        'id': json['id'],
    };
}

export function RewardTypeSummaryToJSON(value?: RewardTypeSummary | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'rarity': RarityCodeToJSON(value['rarity']),
        'wheelIds': value['wheelIds'],
        'postWinConfig': RewardPostWinConfigTextToJSON(value['postWinConfig']),
        'rewardCategory': RewardCategoryToJSON(value['rewardCategory']),
        'cashValueInCents': value['cashValueInCents'],
        'quantityPercentage': value['quantityPercentage'],
        'quantity': value['quantity'],
        'rewardName': value['rewardName'],
        'id': value['id'],
    };
}

